// extracted by mini-css-extract-plugin
module.exports = {"PayPalButtonStyle":"Paypal_PayPalButtonStyle__1UakD"};